
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import colors from 'vuetify/lib/util/colors'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

import en from 'vuetify/es5/locale/en'

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#2DC6D6',
        secondary: colors.grey, // #FFCDD2
        accent: '#2DC6D6' // #3F51B5
      }
    }
  },
  lang: {
    locales: { en },
    current: 'en'
  }
}

export default new Vuetify(opts)



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js